export const DYNAMIC_PAGE_TYPES = {
  INDEX_PAGE: 'index',
  ITEM_PAGE: 'item',
} as const

export type DynamicPageType =
  | typeof DYNAMIC_PAGE_TYPES.INDEX_PAGE
  | typeof DYNAMIC_PAGE_TYPES.ITEM_PAGE
